import { render, staticRenderFns } from "./onlineConsult.vue?vue&type=template&id=50168dc9&scoped=true&"
import script from "./onlineConsult.vue?vue&type=script&lang=js&"
export * from "./onlineConsult.vue?vue&type=script&lang=js&"
import style0 from "./onlineConsult.vue?vue&type=style&index=0&id=50168dc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50168dc9",
  null
  
)

export default component.exports